<template>
  <el-dialog
    title="合同付款约定编辑"
    :visible.sync="ydListState"
    append-to-body
    :close-on-click-modal="false"
    :show-close=false
    width="800px"
  >
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="款项阶段" prop="paymentType">
            <el-select v-model="ruleForm.paymentType" placeholder="请选择款项阶段" style="width: 100%;">
              <el-option
                v-for="item in paymentType" :key="item.value"
                :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="付款日期" prop="payTime">
            <el-date-picker type="date" placeholder="选择付款日期" v-model="ruleForm.payTime"
                            style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="付款单位" prop="payCompany">
            <el-input v-model="ruleForm.payCompany" placeholder="请输入付款单位"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收款单位" prop="collectCompany">
            <el-input v-model="ruleForm.collectCompany" placeholder="请输入收款单位"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="付款内容" prop="payCondition">
            <el-input v-model="ruleForm.payCondition" placeholder="请输入付款内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="付款金额" prop="payMmoney">
            <el-input v-model="ruleForm.payMmoney" placeholder="请输入付款金额"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label-width="0">
        <div class="flex align-center justify-around margin-top">
          <el-button plain @click="closeForm('ruleForm')" style="width: 150px;">关闭</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" style="width: 150px;">保存</el-button>
        </div>

      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {paymentType, zhDate} from "@/tools/utils";

export default {
  name: "ydList",
  data() {
    return {
      paymentType: paymentType,
      ruleForm: {
        paymentType: '',      //付款款项
        payTime: '',      //付款日期
        payCompany: '',      //付款单位
        collectCompany: '',      //收款单位
        payCondition: '',      //支付条件
        payMmoney: '',      //支付金额
      },
      rules: {
        paymentType: [{required: true, message: '请选择款项阶段', trigger: 'change'}],
        payTime: [{required: true, message: '请选择付款日期', trigger: 'change'}],
        payMmoney: [{required: true, message: '请输入付款金额', trigger: 'blur'}],
        payCompany: [{required: true, message: '请输入付款单位', trigger: 'blur'}],
        collectCompany: [{required: true, message: '请输入收款单位', trigger: 'blur'}],
        payCondition: [{required: true, message: '请输入付款内容', trigger: 'blur'}],


      }
    }
  },
  props: {
    ydListState: {
      type: Boolean,
      default() {
        return false;
      },
    },
    setId: {
      type: Number,
      default() {
        return 0;
      },
    },
    setItem: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  created() {
  },
  components: {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitInfo()
        }
      });
    },
    submitInfo() {
      this.$api.apiContent
        .addOrUpdateContractPayAppointment({
          mid: this.$store.state.userMid,
          contractId: this.$route.query.htid,
          id: this.setId,
          paymentType: this.ruleForm.paymentType,
          payTime: zhDate(new Date(this.ruleForm.payTime)),
          payCompany: this.ruleForm.payCompany,
          collectCompany: this.ruleForm.collectCompany,
          payCondition: this.ruleForm.payCondition,
          payMmoney: this.ruleForm.payMmoney,
        })
        .then(res => {
          this.$message.success(res.msg)
          this.closeForm('ruleForm')
        })
        .catch(e => {
          this.$message.success(e.msg)
        })
    },
    closeForm(formName) {
      this.$refs[formName].resetFields()
      this.$emit('getYdList')
    }
  },
  filters: {},
  watch: {
    setItem() {
      if (this.setItem) {
        this.ruleForm = {
          paymentType: Number(this.setItem.payment_type),
          payTime: new Date(this.setItem.pay_time),
          payCompany: this.setItem.pay_company,
          collectCompany: this.setItem.collect_company,
          payCondition: this.setItem.pay_condition,
          payMmoney: Number(this.setItem.pay_money)
        }
      }
    }
  },
}
</script>

<style scoped lang="scss">

</style>
